import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {StyledContainer, StyledUnOrderList} from './styles';

const {topics} =
	translations['pt-br'].privateFlow.myHospitalization.generalOrientations.cards
		.dischargeGuidelines;

export const DischargeGuidelines = () => (
	<StyledContainer>
		<StyledUnOrderList>
			{Object.values(topics).map((text, index) => (
				<li key={index}>
					<Typography variant="body1">{text}</Typography>
				</li>
			))}
		</StyledUnOrderList>
	</StyledContainer>
);
